'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 10;\n  user-select: none;\n  transform: ', ';\n  ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 10;\n  user-select: none;\n  transform: ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 300px;\n  max-width: 100%;\n  padding: 20px 10px;\n  background: ', ';\n  position: relative;\n  border-radius: 10px;\n  font-size: 32px;\n  text-align: center;\n  font-family: Pacifico;\n'], ['\n  width: 300px;\n  max-width: 100%;\n  padding: 20px 10px;\n  background: ', ';\n  position: relative;\n  border-radius: 10px;\n  font-size: 32px;\n  text-align: center;\n  font-family: Pacifico;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bounce = require('bounce.js');

var _bounce2 = _interopRequireDefault(_bounce);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var out = _ref.out;
  return !out ? 'nonw' : 'translateY(-10%)';
}, (0, _polished.transitions)('transform .8s ease-in-out, transform .8s ease-in-out'));

var Box = _styledComponents2.default.div(_templateObject2, _colors.grey);

var ConfettiBox = function (_Component) {
  _inherits(ConfettiBox, _Component);

  function ConfettiBox() {
    _classCallCheck(this, ConfettiBox);

    return _possibleConstructorReturn(this, (ConfettiBox.__proto__ || Object.getPrototypeOf(ConfettiBox)).apply(this, arguments));
  }

  _createClass(ConfettiBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      new _bounce2.default().translate({
        from: {
          x: -300,
          y: 0
        },
        to: {
          x: 0,
          y: 0
        },
        easing: 'bounce',
        duration: 1000,
        delay: 0,
        bounces: 4,
        stiffness: 4
      }).scale({
        from: {
          x: 1,
          y: 1
        },
        to: {
          x: 0.1,
          y: 2.3
        },
        easing: 'sway',
        duration: 800,
        delay: 65,
        bouces: 4,
        stiffness: 2
      }).scale({
        from: {
          x: 1,
          y: 1
        },
        to: {
          x: 5,
          y: 1
        },
        easing: 'sway',
        duration: 300,
        delay: 30,
        bouces: 4,
        stiffness: 3
      }).applyTo(this.dom);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          out = _props.out;
      return _react2.default.createElement(Container, {
        out: out
      }, _react2.default.createElement(Box, {
        innerRef: function innerRef(dom) {
          return _this2.dom = dom;
        }
      }, children));
    }
  }]);

  return ConfettiBox;
}(_react.Component);

ConfettiBox.propTypes = {
  children: _propTypes2.default.node,
  out: _propTypes2.default.bool
};
exports.default = ConfettiBox;